<template>
<div class="text-container">
	<h4>金卡会员简介</h4>
	<p class="p1">常爸说过“父母的能力和格局才是孩子最好的起跑线”，父母提供给孩子的教育资源和自身的育儿理念将可能影响宝贝一生的成长。</p>
	<p class="p1">因此常青藤爸爸一直致力于两个目标，<mark>提供最优质的育儿资源，普及科学权威的育儿理念。</mark></p>
	<p class="p1">为了这两个目标，我们做了几件事：</p>
	<aside>
		<h5>精心制作了将近两千首音频，其中:</h5>
		<ul>
			<li>近300首英文绘本的朗读&歌曲</li>
			<li>80多首中文童话，寓言故事</li>
			<li>近200首国学作品的朗读、律动和哄睡</li>
			<li>近100首唐诗的朗读、律动和讲解</li>
			<li>200多首英文儿歌、纯音乐</li>
			<li>以及更多音频等您来收听</li>
		</ul>
	</aside>
	<p class="p1">所有音频都是我们精心制作的。绘本儿歌的谱曲编曲，由中央音乐学院的作曲家完成；英文的演唱由美国/澳大利亚的专业歌手来唱；中文故事，找的是北京人民广播电台的王牌儿童节目主持人录制的；英文经典儿歌也是美国最专业的Twin Sisters公司授权正版使用……</p>
	<p class="p1"><mark>我们不能代替你陪伴孩子，但是会保证在你陪伴的时间里给孩子最好的声音。</mark></p>
	<p class="p1">我们所精心打造的这些内容，都将提供给金卡会员。</p>

	<span class="line"></span>

	<h4>成为会员您可以</h4>

	<ul class="ul1">
		<li>1.畅听APP上上千首音频内容，以及未来更新的会员专属音频；</li>
		<li>2.立即享受总价值100元的会员专属优惠券礼包，并在会员期享受特殊活动期的会员特惠；</li>
	</ul>
	<p class="p1">陪孩子吃一顿麦当劳要花几十元，你可以用一顿快餐的钱，给孩子最优质的中英文声音，获得权威的科学育儿理念和方法。让我们一起，成为更好的父母！</p>
</div>
</template>
<script>
export default{ }
</script>
<style lang="less">
@import (reference) url(../project.less);
.text-container{
	padding: 0 0.74rem;
	h4{
		font-size: 0.92rem;
		font-weight: 600;
		line-height: 1.8;
		color: @text1;
	}
	p.p1{
		font-size: 0.74rem;
		color: #555;
		line-height: 1.6;
		padding: 0.17rem 0;
		mark{
			background-color: transparent;
			color: #b57800;
		}
	}
	aside{
		margin: 0.69rem 0;
		background-color: #f3f3f3;
		border: 0.02rem #a69b87 solid;
		border-radius: 0.2rem;
		padding: 0.86rem 1.38rem;
		display: inline-block;
		box-sizing: border-box;
		width: 100%;
		h5{
			font-size: 0.86rem;
			font-weight: normal;
			color: @text1;
			position: relative;
			height: 1.12rem;
			&:before{
				content: "";
				position: absolute;
				width: 0.69rem;
				height: 0.69rem;
				background-color: #dbb15d;
				top: 50%;
				margin-top: -0.34rem;
				left: -1.03rem;
			}
		}
		ul{
			padding-top: 0.4rem;
			li{
				.cells;
				font-size: 0.72rem;
				line-height: 1.5;
				color: #444;
				&:before{
					content: "";
					background-color: #444444;
					height: 0.23rem;
					width: 0.23rem;
					.radius;
					margin-top: 0.43rem;
					margin-right: 0.34rem;
				}
			}
		}
		p.p2{
			font-size: 0.72rem;
			line-height: 1.5;
			color: #444;
			mark{
				background-color: transparent;
				color: #b57800;
			}
		}
	}
	ul.ul1{
		padding-bottom: 0.86rem;
		li{
			font-size: 0.80rem;
			color: #555;
			line-height: 1.8;
			padding: 0.17rem 0;
		}
	}
	padding-bottom: 5.81rem;
	span.line{
		display: block;
		padding-top: 0.86rem;
		margin-bottom: 0.69rem;
		.vux-1px-b;
		&:after{
			border-color: #efefef;
		}
	}
}
</style>
